export default __webpack_public_path__ + "static/media/carousel.e188700e.png";